var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 d-flex flex-column"
  }, [_c('p', [_vm._v("系統編號：" + _vm._s(_vm.customer.id))]), _c('p', [_vm._v("來源通路：" + _vm._s(_vm.customer.merchant.type) + ":" + _vm._s(_vm.customer.merchant.name) + ":" + _vm._s(_vm.customer.merchant.type_name))]), _c('p', [_vm._v("系統編號：" + _vm._s(_vm.customer.outer_code))]), _c('p', [_vm._v("姓名：" + _vm._s(_vm.customer.name))])]), _c('div', {
    staticClass: "col-12"
  }, [_c('b-button', {
    attrs: {
      "variant": _vm.isActive('CustomerDetailView')
    },
    on: {
      "click": function click($event) {
        return _vm.go('CustomerDetailView');
      }
    }
  }, [_vm._v("基本資料")]), _vm.customer.has_cross_merchant ? _c('b-button', {
    attrs: {
      "variant": _vm.isActive('CustomerListByUserID')
    },
    on: {
      "click": function click($event) {
        return _vm.go('CustomerListByUserID');
      }
    }
  }, [_vm._v(" 來源通路 ")]) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.CUSTOMER_STAFF_VIEW) ? _c('b-button', {
    attrs: {
      "variant": _vm.isActive('CustomerStaffList')
    },
    on: {
      "click": function click($event) {
        return _vm.go('CustomerStaffList');
      }
    }
  }, [_vm._v(" 所屬業務 ")]) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }